module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "calibre_7",
    attrs: {
      "id": "filepos4001"
    }
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("First Sentient Publications edition 2006"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("Copyright © 2006 by David Parrish")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_8"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("All rights reserved. This book, or parts thereof, may not be reproduced in any form without permission, except in the case of brief quotations embodied in critical articles and reviews.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_8"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("A paperback original")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_8"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("Cover design by Kim Johansen, Black Dog Design"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("Book design by Nicholas Cummings")])]), _vm._v(" "), _c('hr', {
    staticClass: "calibre10"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_6"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_8"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("Parrish, David, MD.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_9"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("Nothing I see means anything : quantum questions, quantum answers / David Parrish.— 1st Sentient Publications ed.")])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_10"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("p. cm.")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("ISBN 978-1-5918-1138-4")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("1. Consciousness. 2. Quantum theory. 3. Mysticism. I. Title.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_8"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("BF311.P31368 2005"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("150—dc22")])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_10"
  }, [_c('p', {
    staticClass: "calibre_12"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("2005029685")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_8"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("10 9 8 7 6 5 4 3 2")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_vm._v("SENTIENT PUBLICATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_6"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("A Limited Liability Company"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("1113 Spruce Street"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("Boulder, CO 80302"), _c('br', {
    staticClass: "calibre1"
  }), _c('a', {
    attrs: {
      "href": "http://www.sentientpublications.com",
      "target": "_blank"
    }
  }, [_vm._v("www.sentientpublications.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "mbp_pagebreak",
    attrs: {
      "id": "calibre_pb_2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bc70b4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_002.vue
// module id = 66
// module chunks = 0